import { render, staticRenderFns } from "./TestQueryClose.vue?vue&type=template&id=5b7b48ae&scoped=true&"
import script from "./TestQueryClose.vue?vue&type=script&lang=js&"
export * from "./TestQueryClose.vue?vue&type=script&lang=js&"
import style0 from "./TestQueryClose.vue?vue&type=style&index=0&id=5b7b48ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7b48ae",
  null
  
)

export default component.exports